const sharedKeywords = [
  "XMP",
  "app UA operating layer",
  "performance marketing platform",
  "Meta TikTok Google AppLovin Mintegral",
  "MMP integration",
  "multi-account ad tool",
];

const sharedAudience = {
  name: "XMP",
  who: [
    { text: "Built for " },
    { text: "app and game UA teams", strong: true },
    { text: " and the agencies serving them." },
  ],
  description:
    "The operating layer for app and game UA. Meta, TikTok, Google, Apple Ads, Snapchat and SDK networks in one workflow, with MMP attribution and mediation revenue built in.",
  rows: [
    ["Customer pattern", "App developers and mobile game studios."],
    [
      "Primary jobs",
      "Cross-channel media buying / ROAS optimization / Multi-account ops / SDK network management",
    ],
  ],
};

const commonCapabilities = {
  campaign: {
    id: "cap-campaign",
    tab: "Campaign",
    tag: "02 / Campaign",
    title: "Create & manage campaigns",
    titleAccent: "in bulk.",
    description:
      "Bulk creation across platforms, accounts and countries in one go. XMP enables bulk creation across supported social, search, app-store and SDK channels.",
    video: "Build",
  },
  automation: {
    id: "cap-automation",
    tab: "Automation",
    tag: "05 / Automation",
    title: "Smart Assistant.",
    titleAccent: "24/7 campaign management.",
    description:
      "Custom rules and bulk actions across supported XMP channels: turn campaigns, ad groups and sub-channels on or off; adjust CPI, CPA and target ROAS bids; update campaign, ad-group or country budgets; create or duplicate campaigns, ad groups and ads; and delete creatives.",
    video: "AI",
  },
  collaboration: {
    id: "cap-collaboration",
    tab: "Collaboration",
    tag: "07 / Collaboration",
    title: "Powerful team collaboration.",
    description:
      "Media buy, design and agency teams in one platform with data segmented by role. Built for the performance trio of buyer, designer and manager.",
    video: "Team",
  },
};

const commonFaq = [
  [
    "Does XMP integrate with MMPs like AppsFlyer and Adjust?",
    "Yes. MMP data integration is an advanced XMP feature, with native support for AppsFlyer, Adjust, Singular, SolarEngine and Tenjin, plus mediation platforms MAX and TopOn for revenue postbacks.",
  ],
  [
    "Is there a free trial for XMP?",
    "Yes. Any customer can apply for a 7-day free trial of XMP with no credit card required. Eligible teams can start with a free tier on top of that. There is no media-spend minimum.",
  ],
];

export const trialPerks = [
  [
    { text: "Run " },
    { text: "Meta plus TikTok, Google, Apple Ads, Snapchat", strong: true },
    { text: " and SDK networks" },
  ],
  [
    { text: "Connect " },
    { text: "AppsFlyer, Adjust, Singular, SolarEngine and Tenjin", strong: true },
  ],
  [
    { text: "Optimize " },
    { text: "AppLovin, Mintegral, Unity and Liftoff / Vungle", strong: true },
    { text: " by publisher / sub-channel" },
  ],
  [
    { text: "Choose " },
    { text: "Annual SaaS or Monthly 0.5% of ad spend", strong: true },
  ],
];

export const stats = [
  {
    prefix: "$",
    value: 5,
    suffix: "B",
    unit: "+",
    label: "Annual ad spend managed",
  },
  { value: 2000, format: "locale", label: "Ad accounts per workspace" },
  { value: 70, unit: "%", label: "Less ad creation time" },
  { value: 15, unit: "min", label: "Ad-group data refresh" },
];

export const platformLogoRows = [
  [
    ["google.png", "Google"],
    ["meta.png", "Meta"],
    ["tiktok.png", "TikTok"],
    ["asa.png", "Apple Ads"],
    ["kwai.png", "Kwai"],
    ["huawei.png", "Petal Ads"],
    ["mtg.png", "Mintegral"],
    ["liftoff.png", "Liftoff"],
    ["applovin.png", "AppLovin"],
    ["unity.png", "Unity Ads"],
    ["snapchat.png", "Snapchat"],
  ],
  [
    ["appsflyer.png", "AppsFlyer"],
    ["adjust.png", "Adjust"],
    ["tenjin.png", "Tenjin"],
    ["solorEngine.png", "SolarEngine"],
    ["singular.png", "Singular"],
    ["max.png", "MAX"],
    ["topon.png", "TopOn"],
  ],
];

export const customerLogoRows = [
  [
    ["5game.png", "5game"],
    ["afour.png", "AFour"],
    ["alictus.png", "Alictus"],
    ["amobear.png", "Amobear Studio"],
    ["aplus.png", "APlus"],
    ["apus.png", "APUS"],
    ["athree.png", "A3"],
    ["auroramob.png", "Auroramob"],
    ["azu.png", "Azur Games"],
    ["cpushe.png", "Cupshe"],
    ["eyewind.png", "Eyewind"],
    ["gamegoing.png", "GameGoing"],
  ],
  [
    ["gamehaus.png", "Gamehaus"],
    ["hang.png", "Hang"],
    ["hyber.png", "Hyber Media"],
    ["igg.png", "IGG"],
    ["ilana.png", "iLana"],
    ["joypac.png", "JoyPac"],
    ["kaixin.png", "Kaixin"],
    ["marature.png", "Mirature"],
    ["master lex.png", "Master Lex"],
    ["mele.png", "Mele Studio"],
    ["mib.png", "MIB"],
    ["mobplus.png", "Mobplus"],
  ],
  [
    ["olivemedia.png", "Olive Media"],
    ["papa.png", "Papa"],
    ["seven.png", "Seven Pirates"],
    ["shareit.png", "SHAREit"],
    ["sharp.png", "Sharp Network"],
    ["sofish.png", "Sofish"],
    ["supercent.png", "Supercent"],
    ["superstar.png", "Super Star"],
    ["touka.png", "Touka"],
    ["udogame.png", "Udo Games"],
    ["vtcmobile.png", "VTC Mobile"],
    ["wtemedia.png", "WTE Media"],
  ],
];

export const complianceBadges = [
  ["nda", "NDA Protected"],
  ["ccpa", "CCPA Certification"],
  ["eprivacyseal", "EU ePrivacyseal Certification"],
  ["aicpa", "SOC3, SOC2 Type 1 & 2"],
];

const comparisonPages = {
  madgicx: {
    slug: "madgicx",
    name: "Madgicx",
    path: "/en/comparison/xmp-vs-madgicx",
    title: "The Madgicx Alternative for App and Game UA Teams | XMP",
    description:
      "XMP is the Madgicx alternative for app and game UA teams: manage 11 ad channels, MMP attribution, SDK traffic and bulk campaign operations in one workflow.",
    keywords: ["Madgicx alternative", ...sharedKeywords].join(", "),
    headline: "The Madgicx Alternative for App and Game UA Teams",
    signupUrl:
      "https://xmp.mobvista.com/m/sign-up?utm_source=webpage&utm_medium=marketing&utm_campaign=madgicx-alternative-page&from_type=marketing&referer=madgicx-alternative-page&landing_site=official_en",
    hero: {
      greeting: [
        { text: "When Meta is " },
        { text: "no longer enough.", accent: true },
      ],
      titleLines: [
        { text: "The Madgicx alternative" },
        { text: "for teams moving", accent: true },
        { text: "beyond Meta.", highlight: true },
      ],
      lede: [
        { text: "Madgicx is strong for Meta-first advertisers. " },
        {
          text: "XMP is built for app and",
          strong: true,
        },
        {
          text: " game teams that need Meta, TikTok, Google, Apple Ads, Snapchat and",
          strong: true,
          wideBreakBefore: true,
        },
        {
          text: " SDK networks in one workflow",
          strong: true,
          wideBreakBefore: true,
        },
        { text: ", with MMP attribution, mediation revenue" },
        { text: " and ", wideBreakBefore: true },
        { text: "sub-channel ROAS built in.", strong: true },
      ],
    },
    audienceIntro:
      "Madgicx and XMP both manage ad campaigns. But they solve different problems. The question is which one is for you.",
    audiences: [
      {
        name: "Madgicx",
        who: [
          { text: "Built for " },
          { text: "DTC brands and small agencies", strong: true },
          { text: " running Meta ads." },
        ],
        description:
          "An ad management tool focused primarily on Meta (Facebook and Instagram). Built for DTC brands, Shopify sellers, and small agencies that want an AI assistant to audit Meta accounts and generate creatives.",
        rows: [
          ["Customer pattern", "DTC, Shopify sellers, small agencies, freelancers running performance on Meta."],
          ["Primary jobs", "Meta automation / AI creative / Daily account audits / Self-serve workflows"],
          ["Success metric", "Meta ROAS / CPA / Creative refresh"],
        ],
      },
      {
        ...sharedAudience,
        rows: [...sharedAudience.rows, ["Success metric", "ROAS / CPA / Ad management time / Revenue"]],
      },
    ],
    tableIntro:
      "A feature-by-feature look at what XMP and Madgicx each support. Where they overlap, and where they don't.",
    comparisonRows: [
      ["Best fit", "App / game UA teams scaling beyond Meta", "Meta-first DTC and ecommerce teams"],
      ["Channels", { text: "Social, search, app-store and SDK networks", status: "yes" }, "Strongest around Meta-first workflows"],
      ["SDK networks", { text: "AppLovin, Mintegral, Unity, Liftoff / Vungle", status: "yes" }, { text: "Not built for SDK-network buying", status: "no" }, "Direct buying on SDK ad networks"],
      ["MMP attribution", { text: "Advanced MMP data integration: AppsFlyer, Adjust, Singular, SolarEngine, Tenjin", status: "yes" }, { text: "Not the app-UA attribution layer", status: "no" }],
      ["Mediation revenue", { text: "MAX / TopOn revenue in the ROAS workflow", status: "yes" }, { text: "Not the core workflow", status: "no" }],
      ["Sub-channel optimization", { text: "Publisher / sub-channel ROAS, eCPM, IVR, CPI", status: "yes" }, { text: "Not available as a core workflow", status: "no" }],
      ["Bulk ops", { text: "Cross-account, cross-country, cross-currency, cross-channel", status: "yes" }, "Better fit for Meta workflows"],
      ["Pricing", "Annual SaaS or Monthly 0.5% of ad spend", "Spend-tier / add-on based pricing"],
      ["Shopify", { text: "Not XMP's focus", status: "no" }, { text: "Stronger Shopify / DTC fit", status: "yes" }],
    ],
    capabilities: [
      {
        id: "cap-integrations",
        tab: "Integrations",
        tag: "01 / Integrations",
        title: "Manage all advertising platforms in one stop.",
        description: "11 channels including SDK networks (AppLovin, Mintegral, Unity and Liftoff / Vungle) supported natively by XMP.",
        video: "Manage",
      },
      commonCapabilities.campaign,
      {
        id: "cap-tagging",
        tab: "Tagging",
        tag: "03 / Tagging",
        title: "Smart tagging at every level of the ad stack.",
        description: 'AI auto-tags creatives by element (hook, character, end-card, style, music) for ROAS-driven analysis. Add custom labels at any level (campaign, ad set, ad) like "auto-optimized" or "auto-create series". XMP connects creative elements with cross-channel CTR, CVR, ROAS and retention data across accounts and ads, so teams can evaluate creative performance in one view.',
        video: "Info",
      },
      {
        id: "cap-sdk",
        tab: "SDK traffic",
        tag: "04 / SDK traffic",
        title: "SDK traffic pool with sub-channel-level analytics.",
        description: "Direct inventory access across supported SDK networks (AppLovin, Mintegral, Unity and Liftoff / Vungle), with sub-channel ROAS, eCPM, IVR and CPI in one dashboard. A native XMP capability for UA teams.",
        video: "Continuation",
      },
      commonCapabilities.automation,
      {
        id: "cap-analysis",
        tab: "Analysis",
        tag: "06 / Analysis",
        title: "Multi-dimensional and visual data analysis.",
        description: "Ad platforms, MMPs and BI in one dashboard. ROAS by app, campaign or creative. Madgicx reports primarily within Meta; XMP connects ad platforms, MMP attribution and mediation revenue for UA decisions.",
        video: "Record",
      },
      commonCapabilities.collaboration,
    ],
    valueBanner: { text: "Built for what comes", pill: "after Madgicx." },
    pricing: {
      heading: ["Two pricing models.", "Pick what fits your team."],
      description: "Madgicx starts at $45/month. XMP monthly pricing is 0.5% of ad spend, with no minimum platform fee — $15 at $3,000 monthly spend and $45 at $9,000.",
      cards: [
        {
          name: "XMP",
          rate: "0.5%",
          rateDetail: "of ad spend · monthly",
          note: [
            "No minimum platform fee. $15 at $3K monthly spend;",
            "$45 at $9K.",
          ],
          featured: true,
          features: [
            "7-day free trial, no credit card required",
            "Annual SaaS or Monthly 0.5% of ad spend",
            "11 supported channels across social and SDK",
            "Mediation revenue reporting in the ROAS workflow",
            "Bulk operations across up to 2,000 ad accounts",
            "Advanced features include MMP data integration, Open API and AI Skill support",
            "Guided onboarding, AI and human support, campaign specialist guidance, plus video and documentation resources.",
          ],
        },
        {
          name: "Madgicx",
          rate: "$45+",
          rateDetail: "starting / per month",
          note: "Starts at $45/month for 2 ad accounts. Credit card required for trial.",
          features: ["Meta-first campaign optimization", "Starting plan: 2 ad accounts", "Credit card required for trial", "AI Marketer included", "Self-serve onboarding"],
        },
      ],
    },
    faq: [
      ["Why is XMP a better alternative to Madgicx?", "XMP runs 11 ad channels with native MMP integration, mediation revenue tracking and SDK sub-channel optimization. Madgicx focuses primarily on Meta. XMP brings cross-channel media, SDK-network buying and UA operations into one workflow."],
      ["What is SDK sub-channel optimization and why does it matter?", "SDK ad networks like Mintegral, AppLovin, Unity and Liftoff / Vungle serve your ads inside other apps called publisher sub-channels. XMP surfaces ROAS, eCPM, IVR and CPI for each. Madgicx is primarily Meta, so this layer isn't available there."],
      ["How much does Madgicx cost compared to XMP?", "Madgicx starts at $45/month for 2 ad accounts. XMP monthly pricing is 0.5% of ad spend with no minimum platform fee - $15 at $3,000 monthly spend and $45 at $9,000. Annual SaaS is also available for teams that prefer predictable yearly planning."],
      ["Where does XMP go beyond Madgicx?", "Madgicx is a strong Meta-first platform for DTC and ecommerce advertisers. XMP goes further for app and game UA teams: cross-channel campaign management, SDK-network buying, MMP attribution, mediation revenue, publisher / sub-channel analytics and bulk operations across accounts, countries and channels."],
      ...commonFaq,
    ],
    bottomLine: "Madgicx is a strong Meta-first tool for DTC and ecommerce advertisers. XMP is the better fit when app and game teams need to scale beyond Meta into TikTok, Google, Apple Ads, Snapchat and SDK networks, with MMP attribution and mediation revenue in one ROAS workflow.",
  },
  smartly: {
    slug: "smartly",
    name: "Smartly",
    path: "/en/comparison/xmp-vs-smartly",
    title: "The Smartly Alternative for App UA Teams | XMP",
    description: "XMP is the Smartly alternative for app and game UA teams: manage 11 ad channels, SDK traffic, MMP data and bulk campaign operations in one workflow.",
    keywords: ["Smartly alternative", ...sharedKeywords].join(", "),
    headline: "The Smartly Alternative for App UA Teams That Need SDK-Network Depth",
    signupUrl: "https://xmp.mobvista.com/m/sign-up?utm_source=webpage&utm_medium=marketing&utm_campaign=smartlyio-alternative-page&from_type=marketing&referer=smartlyio-alternative-page&landing_site=official_en",
    hero: {
      greeting: [
        { text: "Smartly is a powerful enterprise creative and media suite. " },
        { text: "It is not an SDK-network UA layer.", accent: true },
      ],
      titleLines: [
        { text: "The Smartly alternative" },
        { text: "for app UA teams that", accent: true },
        { text: "need SDK-network depth.", highlight: true },
      ],
      lede: [
        { text: "Smartly is strong for enterprise performance teams that need creative automation, dynamic feeds and paid social workflows. " },
        { text: "XMP is built for app and game UA teams that need SDK-network buying, MMP attribution, mediation revenue and publisher / sub-channel ROAS", strong: true },
        { text: " " },
        { text: "in one operating layer.", accent: true, strong: true },
      ],
    },
    audienceIntro: "Smartly and XMP both manage ad campaigns. But they solve different problems. The question is which one is for you.",
    audiences: [
      {
        name: "Smartly",
        who: [
          { text: "Built for " },
          { text: "enterprise brands and performance teams", strong: true },
          { text: " that need creative automation at scale." },
        ],
        description: "An enterprise creative, feed and media automation suite. Strong for dynamic feeds, localized creative and paid social workflows, across enterprise performance use cases.",
        rows: [
          ["Customer pattern", "Enterprise brands and performance teams running creative, media and automation workflows at scale."],
          ["Primary jobs", "Creative automation / Dynamic feeds / Paid social at scale / CTV and open web buying"],
          ["Success metric", "ROAS / Creative velocity / Brand lift / Incrementality"],
        ],
      },
      {
        ...sharedAudience,
        rows: [...sharedAudience.rows, ["Success metric", "ROAS / CPA / LTV / Revenue"]],
      },
    ],
    tableIntro: "A feature-by-feature look at what XMP and Smartly each support. Where they overlap, and where they don't.",
    comparisonRows: [
      ["Best fit", "App / game UA teams scaling SDK and social channels", "Enterprise brands and performance teams running creative, media and automation workflows at scale"],
      ["Platform shape", "UA operating layer", "Enterprise creative, feed and media automation suite"],
      ["SDK networks", { text: "AppLovin, Mintegral, Unity, Liftoff / Vungle", status: "yes" }, { text: "Not an SDK-network buying and sub-channel optimization layer", status: "no" }, "Direct buying on SDK ad networks"],
      ["MMP data", { text: "Advanced MMP data integration with campaign, SDK and monetization reporting", status: "yes" }, { text: "Can use MMP / third-party data for optimization", status: "yes" }],
      ["Mediation revenue", { text: "MAX / TopOn revenue in UA reporting", status: "yes" }, { text: "Not the core workflow", status: "no" }],
      ["Publisher / sub-channel", { text: "ROAS, eCPM, IVR, CPI by publisher / sub-channel", status: "yes" }, { text: "Not the core workflow", status: "no" }],
      ["Creative", "Tags + ROAS analysis for creative elements", { text: "Major strength: DCO, templates, dynamic odds, localized creative", status: "yes" }],
      ["Automation", { text: "Bid, budget, on/off and alerts across supported XMP channels", status: "yes" }, { text: "Strong feed, creative and paid social automation", status: "yes" }],
      ["CTV / Open Web", { text: "Not XMP's focus", status: "no" }, { text: "Smartly strength", status: "yes" }],
      ["Pricing", "Annual SaaS or Monthly 0.5% of ad spend", "Enterprise quote-based pricing"],
    ],
    capabilities: [
      {
        id: "cap-integrations",
        tab: "Integrations",
        tag: "01 / Integrations",
        title: "Manage all advertising platforms in one stop.",
        description: "Run 11 channels including SDK networks (AppLovin, Mintegral, Unity and Liftoff / Vungle) in one UA operating layer.",
        video: "Manage",
      },
      commonCapabilities.campaign,
      {
        id: "cap-tagging",
        tab: "Tagging",
        tag: "03 / Tagging",
        title: "Smart tagging at every level of the ad stack.",
        description: 'AI auto-tags creatives by element (hook, character, end-card, style, music) for ROAS-driven analysis. Add custom labels at any level (campaign, ad set, ad) like "auto-optimized" or "auto-create series". Smartly produces creative variants; XMP tells you which elements actually convert, and lets you label everything else.',
        video: "Info",
      },
      {
        id: "cap-sdk",
        tab: "SDK traffic",
        tag: "04 / SDK traffic",
        title: "SDK traffic pool with sub-channel-level analytics.",
        description: "Direct inventory access across supported SDK networks (AppLovin, Mintegral, Unity and Liftoff / Vungle), with sub-channel ROAS, eCPM, IVR and CPI in one dashboard. A layer XMP adds native SDK-network buying for UA teams.",
        video: "Continuation",
      },
      commonCapabilities.automation,
      {
        id: "cap-analysis",
        tab: "Analysis",
        tag: "06 / Analysis",
        title: "Multi-dimensional and visual data analysis.",
        description: "Ad platforms, MMPs and BI in one dashboard. ROAS by app, campaign or creative. Smartly optimizes creative and paid social performance; XMP connects ad platforms, MMP attribution and mediation revenue for UA decisions.",
        video: "Record",
      },
      commonCapabilities.collaboration,
    ],
    valueBanner: { text: "SDK depth. MMP attribution. Mediation revenue.", pill: "One UA operating layer." },
    pricing: {
      heading: ["Predictable pricing.", "No enterprise minimum."],
      description: "Smartly is commonly sold as an enterprise platform. XMP gives performance teams two clearer options: Annual SaaS for predictable planning, or Monthly pricing at 0.5% of ad spend for spend-based flexibility.",
      cards: [
        {
          name: "XMP",
          rate: "0.5%",
          rateDetail: "of ad spend · monthly",
          note: "No minimum platform fee. Monthly pricing at 0.5% of ad spend, or Annual SaaS for predictable yearly planning.",
          featured: true,
          features: [
            "7-day free trial, no credit card required",
            "Annual SaaS or Monthly 0.5% of ad spend",
            "Multiple plan tiers from Basic to VIP",
            "Up to 2,000 ad accounts and 100 seats",
            "11 supported channels across social and SDK",
            "Advanced features include MMP data integration, Open API and AI Skill support",
            "Guided onboarding, AI and human support, campaign specialist guidance, plus video and documentation resources.",
          ],
        },
        {
          name: "Smartly",
          rate: "Enterprise",
          rateDetail: "quote-based",
          note: "Commonly sold as an enterprise platform with quote-based contracts.",
          features: ["Creative, Media, Intelligence suites", "Social, CTV, open-web DSPs", "Incrementality (INCRMNTAL)", "24/7 managed support", "Quote-based enterprise contracts"],
        },
      ],
    },
    faq: [
      ["Why choose XMP instead of Smartly?", "Choose Smartly for enterprise creative automation, dynamic feeds and media workflows. Choose XMP for an app and game UA operating layer that connects cross-channel buying, SDK networks, MMP data, mediation revenue and ROAS-driven operations."],
      ["What is SDK sub-channel optimization and why does it matter?", "SDK ad networks like AppLovin, Mintegral, Unity and Liftoff / Vungle serve your ads inside other apps called sub-channels. XMP surfaces sub-channel-level metrics including ROAS, eCPM, IVR and CPI so you can pause underperforming publishers and scale winners. Smartly is not an SDK-network buying layer, so publisher-level optimization is not its core workflow."],
      ["How much does Smartly cost compared to XMP?", "Smartly is commonly sold as an enterprise platform with quote-based pricing. XMP gives performance teams two clearer options: Annual SaaS for predictable planning, or Monthly pricing at 0.5% of ad spend for spend-based flexibility."],
      ["Does Smartly support app-UA networks like AppLovin and Mintegral?", "Smartly can use MMP / third-party data for optimization, but it is not an SDK-network buying layer. It does not natively buy on app-UA networks like AppLovin, Mintegral, Unity or Liftoff / Vungle. XMP supports all of these natively."],
      ...commonFaq,
    ],
    bottomLine: "Smartly is powerful for enterprise creative automation, dynamic feeds and media workflows. XMP is sharper for app and game UA teams that need SDK-network optimization, mediation revenue, publisher / sub-channel analytics and bulk campaign operations in one operating layer.",
  },
};

export default comparisonPages;
